// Packages components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Components
import CartItemTicket from "../CartItemTicket";

// Utils
import { formatFechaHoraEvento } from "@/lib/utilsUI";
import { Link } from "react-router-dom";

export default function CartTickets({
  tickets,
  eventoInfo,
  carritoUid,
  onBack,
  isUpdatingCart,
  setIsUpdatingCart,
}) {
  return (
    <div className="mt-4">
      {/* Event Info Header */}
      {eventoInfo && (
        <div className="mb-4 p-3 bg-aw-bluedark rounded-lg border border-aw-green">
          <div className="flex items-center gap-3">
            <img
              src={eventoInfo.img}
              alt={eventoInfo.nombre}
              className="w-12 h-12 rounded-lg object-cover border border-aw-green"
            />
            <div>
              <h3 className="text-white font-bold text-sm line-clamp-1">
                {eventoInfo.nombre}
              </h3>
              <p className="text-gray-400 text-xs">
                {formatFechaHoraEvento(new Date(eventoInfo.fecha))}
              </p>
              {/* <p className="text-gray-400 text-xs">
                <FontAwesomeIcon icon="fa-solid fa-map-marker-alt" className="text-red-500 mr-1" />
                {eventoInfo.ubicacion}
              </p> */}
              <a
                href={`/evento/${eventoInfo.eventoUid}`}
                // Close the cart modal and navigate to event detail
                onClick={() => {
                  onBack();
                }}
                className="text-aw-green text-xs underline"
              >
                Ver detalles del evento
              </a>
            </div>
          </div>
        </div>
      )}

      <div className="w-full">
        {/* Header */}
        <div className="flex text-left text-white text-sm font-bold border-b border-aw-bluedark-50 pb-2">
          <div className="flex-1">Detalle</div>
          <div className="w-20 text-right">Cant.</div>
          <div className="w-24 text-center">Pago</div>
        </div>
        {/* Body */}
        <div className="max-h-[57dvh] sm:max-h-[60dvh] overflow-y-auto scrollbar-box thin pr-2">
          {tickets.map((ticket) => (
            <CartItemTicket
              key={`${carritoUid}-${ticket.tipoTicketId}`}
              ticket={ticket}
              eventoId={eventoInfo?.id || eventoInfo?.eventoId}
              carritoUid={carritoUid}
              imgEvento={eventoInfo?.img || eventoInfo?.eventoImg}
              isUpdatingCart={isUpdatingCart}
              setIsUpdatingCart={setIsUpdatingCart}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
